import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { byttSprak, SPRAK } from '../i18n';

/** Språket som en stille segmentvelger. */
export default function SprakVelger() {
  const { t, i18n } = useTranslation();

  return (
    <div role="group" aria-label={t('sprak.velg')} className="flex items-center gap-2">
      <Languages aria-hidden="true" className="h-4 w-4 text-slate-400" />
      <div className="flex rounded-lg bg-slate-100 p-0.5">
        {SPRAK.map((sprak) => {
          const valgt = i18n.resolvedLanguage === sprak;
          return (
            <button
              key={sprak}
              type="button"
              lang={sprak}
              aria-pressed={valgt}
              onClick={() => byttSprak(sprak)}
              className={
                'rounded-md px-2.5 py-1 text-[13px] font-medium transition-colors ' +
                (valgt ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-900')
              }
            >
              {t(`sprak.${sprak}`)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
